import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import LabelsToolContent from '../LabelsToolContent';
import LabelEditPopup from './LabelEditPopup';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';
import { selectCurrentUserLabels } from '../../../../../../element/labels/labelSelectors';
import { Label } from '../../../../../../../common/labels/labelTypes';

const LabelsToolbarPopupContent: React.FC<LabelsToolbarPopupProps> = (props) => {
    const [showEditingPopup, setShowEditingPopup] = useState<boolean>(false);
    const [currentlyEditingLabelId, setCurrentlyEditingLabelId] = useState<string | null>(null);
    const [showColorChange, setShowColorMenu] = useState<boolean>(false);

    const labels = useSelector(selectCurrentUserLabels);
    const currentlyEditingLabel = labels?.[currentlyEditingLabelId || ''] || null;
    const allLabels = Object.values(labels || {});

    const handleClickEdit = (label: Label) => {
        const isOpeningPopup = currentlyEditingLabelId !== label.id;
        setCurrentlyEditingLabelId(isOpeningPopup ? label.id : null);
        setShowEditingPopup(isOpeningPopup);

        if (isOpeningPopup) {
            setShowColorMenu(false);
        }
    };

    const handleClickColorChange = () => {
        setShowColorMenu((currentShowColorMenu) => !currentShowColorMenu);
    };

    return (
        <>
            <LabelsToolContent {...props} allLabels={allLabels} handleClickEdit={handleClickEdit} />
            <LabelEditPopup
                label={currentlyEditingLabel}
                showEditingPopup={showEditingPopup}
                setShowEditingPopup={setShowEditingPopup}
                showColorMenu={showColorChange}
                onColorChangeClick={handleClickColorChange}
            />
        </>
    );
};

export default LabelsToolbarPopupContent;
